import './footer.style.sass';
import template from './footer.tpl.pug';

class FooterController {
    /* @ngInject */
    constructor(configuration) {
        this.configuration = configuration;
    }

    $onInit() {
        this.salesEmail = this.configuration.salesEmail;
        this.facebookUrl = this.configuration.socialFacebookUrl;
        this.twitterUrl = this.configuration.socialTwitterUrl;
        this.helpCenterUrl = this.configuration.helpCenterUrl;
        this.pressKitUrl = this.configuration.pressKitUrl;
    }
}

export default {
    selector: 'dbPFooter',
    template: template(),
    controller: FooterController
};



// WEBPACK FOOTER //
// ./src/presentation/component/footer/footer.cmpt.js